import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import {
  extendParentClass,
  extendBaseClass,
  extend,
} from '../../../utils/classes'

export class Plans extends Component {
  baseClass = extendParentClass.bind(this)('plans')

  extend = extendBaseClass.bind(this)

  selectClass = this.extend('select')

  renderPlans = () => {
    const { plans } = this.props
    return plans.map(({ name }, index) => (
      <option
        value={index}
        key={index}
        className={extend(this.selectClass, 'plan')}
      >
        {name}
      </option>
    ))
  }

  handleSelect = (event) => {
    const { setSelectedPlan } = this.props
    setSelectedPlan(event.target.value)
  }

  render() {
    return (
      <Form.Group controlId="plans" className={this.baseClass}>
        <Form.Label className={this.extend('label')}>
          Pricing Options
        </Form.Label>
        <Form.Control
          as="select"
          onChange={this.handleSelect}
          className={this.selectClass}
          custom
        >
          {this.renderPlans()}
        </Form.Control>
      </Form.Group>
    )
  }
}

export default Plans
